export const COMPANY_NAME = "Stragilia";
export const CONTACT_EMAIL = "contact@stragilia.com";
export const CONTACT_PHONE = "+33 7 62 90 46 58";
export const CONTACT_PHONE_RAW = "+33762904658";
export const WHATSAPP_NUM = "+33762904658";
export const CALENDLY_URL = "https://calendly.com/votre-societe/rdv-30min";
export const COMPANY_ADDRESS = "Paris, France";
export const LINKEDIN_URL = "https://www.linkedin.com";
export const REGISTER_URL = "https://app.stragilia.com/selectModules.php";

export const AVAILABLE_MODULES = [
  {
    name: "Logistics",
    submodules: ["Supply"]
  }
];

export const DEFAULT_P = {
  header: "sticky top-0 z-40 backdrop-blur border-b border-black/5 bg-white/70 dark:bg-indigo-950/70",
  headerTitle: "text-xl",
  card: "bg-white dark:bg-indigo-900/60 ring-1 ring-black/5 dark:ring-white/10",
  cardTitle: "text-gray-900 dark:text-white",
  cardP: "text-gray-600 dark:text-gray-200",
  breadcrumbLink: "text-gray-700 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white",
  ctaSecondary: "rounded-lg ring-1 ring-gray-300 dark:ring-white/20 px-4 py-2 font-semibold hover:bg-black/5 dark:hover:bg-white/10",
  ctaPrimary:
    "rounded-lg bg-indigo-600 text-white px-4 py-2 font-semibold hover:bg-indigo-700 disabled:opacity-60",
  navLinkIdle:
    "ring-gray-300 dark:ring-white/20 hover:bg-black/5 dark:hover:bg-white/10",
  chip: "rounded-lg ring-1 ring-gray-300 dark:ring-white/20 px-3 py-1 text-sm",
  chipAlt: "rounded-lg bg-black/5 dark:bg-white/10 px-3 py-1 text-sm",
};
